// Shared with the static hero (src/staticHero/), which paints the app bar
// from index.html before the bundle loads.
export const APP_BAR_LOGO =
  'https://assets.askhippo.co.za/Pages/Common/logo-nav.png';
export const APP_BAR_MENU_ICON =
  'https://assets.askhippo.co.za/Icons/nav/menu.svg';
